export const formatDbDate = (str: string): string => {
  const parts = str.substr(0, 10).split('-')
  return `${parts[2]}-${parts[1]}-${parts[0]}`
}

export const formatDbDateTime = (str: string): string => {
  const time = str.substr(11, 5)
  const parts = str.substr(0, 10).split('-')
  return `${parts[2]}-${parts[1]}-${parts[0]} ${time}`
}
